import { render, staticRenderFns } from "./subAccountDetail.vue?vue&type=template&id=191a4d53&scoped=true&"
import script from "./subAccountDetail.vue?vue&type=script&lang=js&"
export * from "./subAccountDetail.vue?vue&type=script&lang=js&"
import style0 from "./subAccountDetail.vue?vue&type=style&index=0&id=191a4d53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191a4d53",
  null
  
)

export default component.exports